"use client";

import { Icona } from "@/components/home/Icona";

/** `classe` e `rimando` servono alla pagina del dispaccio, dove il
 *  comando sta in fila con «Copia link» e «Condividi» (`COMANDO_RIMANDO`
 *  di ShareBar) invece che come targa. */
export function DownloadButton({ classe, rimando = false }: { classe?: string; rimando?: boolean } = {}) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        if (typeof window === "undefined") return;
        // Blank the document title so the browser's auto print header
        // doesn't duplicate the article headline at the top of page 1.
        const originalTitle = document.title;
        document.title = " ";
        // If the article is open as a modal overlay, flag the body so the
        // print stylesheet can hide the underlying feed/paesi page.
        const hasOverlay = !!document.querySelector(
          "[data-article-overlay]"
        );
        if (hasOverlay) document.body.classList.add("is-printing-modal");
        try {
          window.print();
        } finally {
          document.title = originalTitle;
          document.body.classList.remove("is-printing-modal");
        }
      }}
      /* Concatenate e non fuse con `cn`: tailwind-merge non conosce i
         gradini della scala (`text-corpo`) e li scarta come se fossero un
         colore in conflitto con `text-mare`. */
      className={`no-print ${
        classe ?? "cursor-pointer rounded-sm border border-rule bg-transparent px-3 py-1 text-[10px] tracking-comando text-ink"
      }`}
      title="Scarica l'articolo come PDF"
      aria-label="Scarica l'articolo come PDF"
    >
      {rimando ? (
        <>
          <Icona nome="scarica" className="size-[14px]" />
          Scarica PDF
        </>
      ) : (
        "↓ SCARICA PDF"
      )}
    </button>
  );
}
